module.exports = __webpack_public_path__ + "img/Content3.c6e7c976.png";